// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  align-items: center !important;
}

ion-list {
  padding-bottom: 0px;
}

.popover-reconfirmation-title {
  padding: unset;
}

@media screen and (max-width: 420px) {
  .list-md-lines-none .item {
    max-height: 40px;
  }
}

.reconfirm-radio {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-reconfirmation/popover-reconfirmation.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AACA;EACI,cAAA;AAEJ;;AACI;EADJ;IAEI,gBAAA;EAGF;AACF;;AADA;EACI,iBAAA;AAIJ","sourcesContent":["ion-item{\r\n    align-items: center!important;\r\n}\r\n\r\nion-list{\r\n    padding-bottom: 0px;\r\n}\r\n.popover-reconfirmation-title{\r\n    padding: unset;\r\n}\r\n.list-md-lines-none .item {\r\n    @media screen and (max-width:420px){\r\n    max-height: 40px;\r\n    }\r\n}\r\n.reconfirm-radio {\r\n    margin-right: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
